 @if(isLoading()) {
<mat-spinner class="spinner-container" diameter="48"></mat-spinner>
}

@if(!isLoading() && showContainer()) {
<div class="container">
  <div class="title-box">
    <h1 class="title-primary">{{title()}}</h1>
    @if(description()){
    <p class="title-primary-description">{{description()}}</p>}
  </div>
</div>
}